import React from 'react'
import Breadcrumb from '../../../../Components/Utils/Breadcrumb'
import { BackButton } from '../../../../Components/Utils/Buttons'
import { TextMediumSM } from '../../../../Components/Text/MediumText'
import PriorityTask from './Priority'
import StatusTask from './Status'
import DurationTask from './Duration'


function TaskSettings() {
    return(
        <div className='w-full h-full px-4 py-2'>
          <div className='w-full flex justify-between items-center'>
          <Breadcrumb
            items={[
              {
                name: "Settings",
              },
              {
                name: "Task"
              }
            ]}
          />
          <BackButton/>
          </div>
          <div className="p-3 w-full h-[calc(100vh-145px)] bg-white mt-3 mx-auto rounded-md overflow-y-scroll">
          <TextMediumSM content="Task" />
        <div className='w-full flex flex-wrap justify-center md:justify-start  items-center overflow-y-scroll'>
        
         
         <div className=' w-full md:w-1/2 lg:w-1/3 mt-4'>
            <DurationTask/>

         </div>
         <div className=' w-full md:w-1/2 lg:w-1/3 mt-4'>
            <PriorityTask/>
         </div>
         <div className=' w-full md:w-1/2 lg:w-1/3 mt-4'>
            <StatusTask/>
         </div>
        
       
         </div>

          </div>
          </div>
      )
}

export default TaskSettings
